/*global app*/



app.filter('workerOrderFilter', function () {
    return function (input, total) {
        
        function aAttendedBNotAttended(a,b){
            return (a.notAttendedReasonName == null) && (b.notAttendedReasonName != null);
        }
        
        function aNotAttendedBAttended(a,b){
            return (a.notAttendedReasonName != null) && (b.notAttendedReasonName == null);
        }
        
        function aAcceptedBWaiting(a,b){
            return ((a.approved == 1) && (b.approved == 0));
        }
        
        function aWaitingBAccepted(a,b){
            return ((a.approved == 0) && (b.approved == 1));
        }
        
        var objs = []
        function compare(a, b) {
            if (aAttendedBNotAttended(a,b)){
                return -1;
            }
            else if (aNotAttendedBAttended(a,b))
                return 1;
            else{
                if(aAcceptedBWaiting(a,b)){
                    return 1;
                }else if(aWaitingBAccepted(a,b)){
                    return -1;
                }else{
                    return 0;
                }
            }
        }
        Object.keys(input).forEach(function (ind) {
            objs.push(input[ind])
        })


        objs.sort(compare);

        return objs;
    };
});